import { ObjectFieldsChecker } from "../../../../../../tools/ObjectFieldsChecker";
import { BuildingUpgradeItemDto } from "../../../../../networking/data/responses/upgrade/BuildingUpgradeItemDto";
import { UpgradeItemElementType } from "../types/UpgradeItemElementType";
import { UpgradeItemType } from "../types/UpgradeItemType";
import { ItemElement } from "./ItemElement";
import { LockUpgradeItem } from "./LockUpgradeItem";

export class BuildingUpgradeItem {
    public readonly id: UpgradeItemType;
    public readonly title: string;
    public readonly imageUrl: string;
    public readonly elementId: UpgradeItemElementType;
    public readonly lock: LockUpgradeItem;
    public readonly upgradePoints: number;
    public readonly fixCostInCoins: number;
    public readonly upgradeCostInCoins: number;
    public readonly fixCostInTokens: string;
    public readonly upgradeCostInTokens: string;
    public readonly returnedTokensAmountForTokensFix: string;
    public readonly returnedTokensAmountForCoinsFix: string;
    public readonly returnedTokensAmountForTokensUpgrade: string;
    public readonly returnedTokensAmountForCoinsUpgrade: string;
    public readonly elements: ItemElement;

    public constructor(dto: BuildingUpgradeItemDto) {
        this.validateDto(dto);
        this.id = dto.id.toUpperCase() as UpgradeItemType;
        this.title = dto.title.toUpperCase();
        this.imageUrl = dto.imageUrl;
        this.elementId = dto.elementId as UpgradeItemElementType;
        this.lock = new LockUpgradeItem(dto.lock);
        this.upgradePoints = dto.upgradePoints;
        this.fixCostInCoins = dto.fixCostInCoins;
        this.upgradeCostInCoins = dto.upgradeCostInCoins;
        this.fixCostInTokens = dto.fixCostInTokens;
        this.upgradeCostInTokens = dto.upgradeCostInTokens;
        this.returnedTokensAmountForTokensFix = dto.returnedTokensAmountForTokensFix;
        this.returnedTokensAmountForCoinsFix = dto.returnedTokensAmountForCoinsFix;
        this.returnedTokensAmountForTokensUpgrade = dto.returnedTokensAmountForTokensUpgrade;
        this.returnedTokensAmountForCoinsUpgrade = dto.returnedTokensAmountForCoinsUpgrade;
        this.elements = new ItemElement(dto.elements);
    }

    private validateDto(dto: BuildingUpgradeItemDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "id",
            "title",
            "imageUrl",
            "elementId",
            "lock",
            "upgradePoints",
            "fixCostInCoins",
            "upgradeCostInCoins",
            "elements",
            "fixCostInTokens",
            "upgradeCostInTokens",
            "returnedTokensAmountForTokensFix",
            "returnedTokensAmountForCoinsFix",
            "returnedTokensAmountForTokensUpgrade",
            "returnedTokensAmountForCoinsUpgrade"
        ]);
    }
}
